import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import dayjs from 'dayjs'

import { Select } from '@st-operations/uikit/src/v2'
import { logErrorAsync } from '_lib/utility.js'

import { Block } from '.'
import IconDataFeeds from './icons/icon-data-feeds'

import { getEnumDataFeeds, getRecentFeeds } from '_services/dashboard'

const getFeeds = async (creator) => {
  try {
    const feeds = await getRecentFeeds(creator)
    return feeds.items
  } catch (error) {
    logErrorAsync(error)
    return []
  }
}

const getUsers = async () => {
  try {
    return await getEnumDataFeeds()
  } catch (error) {}
}

const Card = ({ feed }) => {
  const { name, updatedAt, deliveries, _id, client } = feed
  return (
    <div className="df-card">
      <div className="df-card__icon">
        <IconDataFeeds size="30px" fill="#13682B" />
      </div>
      <div className="df-card__meta">
        <Link to={`/data-explorer/discovery?audience_id=${_id}`}>{name}</Link>
        <span>{dayjs(updatedAt).format('YYYY-MM-DD - HH:MM')}</span>
      </div>
      <div className="df-card__status">{deliveries.at(0)?.status ?? '-'}</div>
      <div className="df-card__client">
        <b>Client: </b>
        {client?.name ?? ''}
      </div>
    </div>
  )
}

const DataFeedsBlock = ({ currentUser }) => {
  const [feeds, setFeeds] = useState([])
  const [loading, setLoading] = useState(true)
  const [users, setUsers] = useState([])
  const [user, setUser] = useState(currentUser)

  useEffect(() => {
    setLoading(true)
    getFeeds(user).then((feeds) => {
      setFeeds(feeds)
      setLoading(false)
    })
  }, [user])

  useEffect(() => {
    getUsers().then(setUsers)
  }, [])

  return (
    <Block
      title="Data Feeds"
      link="/data-explorer"
      actions={
        <>
          <Select
            name="created_by"
            placeholder="All users"
            options={users}
            value={user}
            onChange={(_, _2, user) => setUser(user)}
            useReactSelect={true}
            isSearchable={true}
            isClearable={true}
          />
        </>
      }
      content={
        loading ? (
          <p className="dashboard__zero-state-message">Loading...</p>
        ) : feeds.length ? (
          feeds.map((feed) => <Card key={feed.name} feed={feed} />)
        ) : (
          <p className="dashboard__zero-state-message">No entries</p>
        )
      }
    />
  )
}

export default DataFeedsBlock
